import axios from 'axios'
import {BRANDS, NULL} from '../actionTypes'
import {getBrandUnreadMessages} from '../../../../../redux/actions/brandsDashboard'

const token = localStorage.getItem(`${process.env.REACT_APP_USERTOKEN}`)

// ** Get Token
const getToken = () => {
    return localStorage.getItem(process.env.REACT_APP_USERTOKEN) ||
           localStorage.getItem('accessToken') ||
           localStorage.getItem('token')
}

// ** Get User Profile
export const getUserProfileFromServer = () => {
    const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
    // console.log('i was called for current user profile', user)
    return dispatch => {
        dispatch({type: BRANDS.CHAT_GET_USER_PROFILE_FROM_SERVER, brandUserProfile: user})
    }
}

// ** GET User Contacts List
export const getChatContactsFromServer = (tab = 'inbox') => {
    return dispatch => {
        axios.get(`${process.env.REACT_APP_BASEURL}brand/load-chat-users?tab=${tab}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${getToken()}`
                }
            }).then(res => {
            dispatch({type: BRANDS.CHAT_CONTACTS, chatContacts: res.data, tab})
        }).catch(e => {
            dispatch({type: "BRAND_CONTACT_LOAD_ERROR", payload: e})
        })
    }
}

export const archiveConversation = (otherUserId) => {
    return dispatch => {
        // Optimistic local update
        dispatch({type: BRANDS.ARCHIVE_CONVERSATION, otherUserId})
        axios.post(`${process.env.REACT_APP_BASEURL}brand/archive-conversation`,
            {other_user_id: otherUserId},
            {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${getToken()}`
                }
            }).then(() => {
                // Re-fetch all 3 tabs so server state is reflected everywhere
                dispatch(getChatContactsFromServer('inbox'))
                dispatch(getChatContactsFromServer('sent'))
                dispatch(getChatContactsFromServer('archive'))
            })
    }
}

export const unarchiveConversation = (otherUserId) => {
    return dispatch => {
        // Optimistic local update
        dispatch({type: BRANDS.UNARCHIVE_CONVERSATION, otherUserId})
        axios.post(`${process.env.REACT_APP_BASEURL}brand/unarchive-conversation`,
            {other_user_id: otherUserId},
            {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${getToken()}`
                }
            }).then(() => {
                // Re-fetch all 3 tabs so server state is reflected everywhere
                dispatch(getChatContactsFromServer('inbox'))
                dispatch(getChatContactsFromServer('sent'))
                dispatch(getChatContactsFromServer('archive'))
            })
    }
}

export const markConversationUnread = (otherUserId) => {
    return dispatch => {
        dispatch({type: 'MARK_BRAND_CONVERSATION_UNREAD', payload: otherUserId})
        axios.post(`${process.env.REACT_APP_BASEURL}brand/mark-conversation-unread`,
            {other_user_id: otherUserId},
            {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${getToken()}`
                }
            }).then(() => {
                dispatch(getChatContactsFromServer('inbox'))
                dispatch(getChatContactsFromServer('sent'))
                dispatch(getChatContactsFromServer('archive'))
            })
    }
}

// ** GET Inactive Conversations (> 6 months) for cleanup popup
export const getInactiveConversations = () => {
    return () => {
        return axios.get(`${process.env.REACT_APP_BASEURL}brand/inactive-conversations`, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${getToken()}`
            }
        })
    }
}

// ** Bulk Archive Conversations
export const bulkArchiveConversations = (otherUserIds) => {
    return dispatch => {
        return axios.post(`${process.env.REACT_APP_BASEURL}brand/bulk-archive-conversations`,
            {other_user_ids: otherUserIds},
            {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${getToken()}`
                }
            }).then(res => {
                // Re-fetch all 3 tabs so server state is reflected everywhere
                dispatch(getChatContactsFromServer('inbox'))
                dispatch(getChatContactsFromServer('sent'))
                dispatch(getChatContactsFromServer('archive'))
                return res
            })
    }
}

// ** ADD New Contact to List

export const addBrandContactsInRedux = obj => {
    return dispatch => {
        dispatch({type: BRANDS.CHAT_ADD_CONTACT, chatContact: obj})

    }
}

//** Get Chat of Selected User

export const changeReduxState = (name, value) => {
    return dispatch => {
        switch (name) {
            case NULL.LOAD_SELECTED_USER_CHAT:
                dispatch({
                    type: BRANDS.LOAD_SELECTED_USER_CHAT,
                    selectedUserBrandChatLoading: value
                })
                break
        }
    }
}

export const selectChatFromServer = id => {
    return dispatch => {
        axios.get(`${process.env.REACT_APP_BASEURL}brand/load-chat-window?user_id=${id}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${getToken()}`
                }
            }).then(res => {
            dispatch({type: BRANDS.SELECTED_USER_CHAT, selectedUserBrandChat: res.data})
            if (res.data && res.data.user) {
                dispatch(selectedContactDetail(res.data.user))
            }
            dispatch(changeReduxState(NULL.LOAD_SELECTED_USER_CHAT, false))
            dispatch(getBrandUnreadMessages())
        }).catch(e => {
            dispatch({type: "BRAND_CHAT_LOAD_ERROR", payload: e})
        })
    }
}

export const getMassMessageDetail = massId => {
    return dispatch => {
        dispatch(changeReduxState(NULL.LOAD_SELECTED_USER_CHAT, true))
        axios.get(`${process.env.REACT_APP_BASEURL}brand/mass-message-detail?mass_id=${massId}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${getToken()}`
                }
            }).then(res => {
            if (res.data && res.data.status && res.data.data) {
                const detail = res.data.data
                const total = detail.total_recipients
                const title = detail.name || detail.title || (total === 1 ? 'Mass Message to 1 Selected RD' : `Mass Message to ${total} Selected RDs`)
                const massUser = {
                    chat_user: `mass_${massId}`,
                    name: title,
                    brand_name: title,
                    user_type: 'mass',
                    role: 'mass',
                    is_mass_group: true,
                    created_at: detail.created_at
                }
                dispatch(selectedContactDetail(massUser))
                dispatch({type: BRANDS.MASS_MESSAGE_DETAIL, massMessageDetail: detail})
            }
            dispatch(changeReduxState(NULL.LOAD_SELECTED_USER_CHAT, false))
        }).catch(e => {
            dispatch(changeReduxState(NULL.LOAD_SELECTED_USER_CHAT, false))
        })
    }
}

export const recieveMsg = obj => {
    return dispatch => {
        dispatch({type: BRANDS.NEW_MESSAGE, message: obj})
    }
}

export const sendMsgRD = obj => {
    const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
    const chatID = user.chat_id
    return dispatch => {
        axios.post(`${process.env.REACT_APP_BASEURL}brand/save-chat-message`, {
            message: obj.message,
            to_user_id: obj.to_user_id,
            from_user_id: chatID,
            timezone: obj.timezone
        }, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${getToken()}`
            }
        }).then(res => {
            dispatch(getChatContactsFromServer('inbox'))
            dispatch(getChatContactsFromServer('sent'))
            dispatch(selectChatFromServer(obj.to_user_id))
            dispatch({type: "SEND_MSG_SUCCESS_RESPONSE", payload: res.data})
        })
    }
}

export const saveBroadcastMessage = (userList) => {
    return dispatch => {
        axios.post(`${process.env.REACT_APP_BASEURL}brand/save-bulk-msg`, userList, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getToken()}`
            }
        }).then(res => {
            dispatch({type: "BROADCAST_SUCCESS_RESPONSE", payload: res.data})
            dispatch(getChatContactsFromServer('inbox'))
            dispatch(getChatContactsFromServer('sent'))
        }).catch((error) => {
            dispatch({type: "BROADCAST_SUCCESS_RESPONSE", payload: error})
        })
    }
}

export const myRdList = () => {
    return dispatch => {
        axios.get(`${process.env.REACT_APP_BASEURL}brand/chat-my-rd-list`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${getToken()}`
                }
            }).then(res => {
            return dispatch({
                type: BRANDS.CHAT_BRAODCAST_CONTACTS,
                braodcastContactList: res.data
            })

        })
            .catch((error) => {
            })
    }
}

export const allRdList = () => {
    return dispatch => {
        axios.get(`${process.env.REACT_APP_BASEURL}brand/all-rds-list`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${getToken()}`
                }
            }).then(res => {
            return dispatch({
                type: BRANDS.CHAT_BRAODCAST_CONTACTS,
                braodcastContactList: res.data
            })
        })
            .catch((error) => {
            })
    }
}

export const sendBroadcastMsg = broadCastMessage => {
    return dispatch => {
        const mdobj = {
            from_user_id: broadCastMessage.from_user_id,
            message: broadCastMessage.message,
            to_users: broadCastMessage.to_users,
            timezone: broadCastMessage.timezone,
            target_title: broadCastMessage.target_title || broadCastMessage.mass_title || '',
            mass_title: broadCastMessage.mass_title || broadCastMessage.target_title || ''
        }
        broadCastMessage.socket.emit("braodcast-message", mdobj)
        dispatch(saveBroadcastMessage(mdobj))
    }
}
export const uploadMediaToserver = obj => {
    return dispatch => {
        const formData = new FormData()
        formData.append("file", obj.file)
        formData.append("user_to_id", obj.to_user_id)
        axios.post(`${process.env.REACT_APP_BASEURL}brand/upload-chat-file`, formData, {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${getToken()}`
            }
        }).then(res => {
            const media = {
                to_user_id: obj.to_user_id,
                media: res.data.media,
                message: "",
                file_name: res.data.file_name,
                from_user_id: obj.from_user_id

            }
            obj.socket.emit("new-media", media)
            dispatch(getChatContactsFromServer('inbox'))
            dispatch(getChatContactsFromServer('sent'))
            dispatch(selectChatFromServer(obj.to_user_id))
            dispatch({type: "SEND_MSG_SUCCESS_RESPONSE", payload: res.data})
        }).catch((error) => {
            console.log('error')
        })
    }
}

export const selectedContactDetail = selectedContact => {
    return dispatch => {
        dispatch({type: BRANDS.CHAT_SELECTED_CONTACT, selectedContactDetail: selectedContact})
    }
}

export const getUserProfile = () => {
    return dispatch => {
        return axios.get('/apps/chatBrands/users/profile-user').then(res => {
            return dispatch({
                type: 'GET_USER_PROFILE',
                userProfile: res.data
            })
        })
    }
}

// ** Get Chats & Contacts // get user chats list
export const getChatContacts = () => {
    return dispatch => {
        dispatch({
            type: 'GET_CHAT_CONTACTS',
            data: []
        })
        // axios.get('/apps/chatBrands/chats-and-contacts').then(res => {
        //   dispatch({
        //     type: 'GET_CHAT_CONTACTS',
        //     data: res.data.data
        //   })
        // })
    }
}

// ** Select Chat
export const selectChat = id => {
    return dispatch => {
        axios.get('/apps/chatBrands/get-chat', {id}).then(res => {
            dispatch({type: 'SELECT_CHAT', data: res.data})
            dispatch(getChatContacts())
        })
    }
}

export const sendMsg = obj => {
    return dispatch => {
        axios.post('/apps/chatRd/send-msg', {obj}).then(res => {
            dispatch({type: 'SEND_MSG', data: res.data})
            dispatch(selectChat(obj.to_user_id))

        })
    }
}
export const receiveTextMessage = message => {
    return dispatch => {
        dispatch({
            type: RECEIVE_NEW_CHAT_MESSAGE,
            payload: message
        })
    }

}
export const storeMessagesInRedux = obj => {
    return dispatch => {
        dispatch({type: 'CHAT_BRAND_WITH_RD', brandsChatWithRd: obj})

    }
}
